const ObjToArr = (items) => {
	let chunk   	= []
	let itemsSize = Object.keys(items).length
	for (const key in items) {
		chunk.push({...items[key], id: key})
	}
	return {
		itemsSize: itemsSize,
		list:      chunk
	}
}
export default ObjToArr